<div id="add-document-dialog" class="{{theme}}">
    <div mat-dialog-title>
        <div class="row">
            <div *ngIf="!content.contentId"  class="col-md-10">
                <h3>Add Document</h3>
            </div>
            <div *ngIf="content.contentId" class="col-md-10">
                <h3>Edit Document</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div class="row">
            <div class="col-md-12 mt-2">
                <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                    <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                        <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                        {{ alert.msg }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">

            <input #addDocumentUploader class="addDocumentUploader" type="file" (click)="addDocumentUploader.value=null" hidden name="avatar"
                (change)="onFileChange($event.target.files)" />


            <button class="col-5 mb-2 btn btn-browse" type="button" (click)="uploadFiles()">{{ "Button.upload_document" | translate}}</button>

        </div>
        <div class="row">
            <mat-form-field class="col-md-10">
                <input matInput placeholder="Document Name" required name="documentName" disabled #tileName1="ngModel" [(ngModel)]="documentName">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col-md-10">
                <input matInput placeholder="Document Display Name" required name="documentDisplayName" #tileName2="ngModel" [(ngModel)]="documentDisplayName">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col-md-10">
                <textarea matInput placeholder="Document Description"  #tileName3="ngModel" [(ngModel)]="documentDescription"></textarea>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col-md-10">
                <textarea matInput placeholder="Search Keywords"  #tileName4="ngModel" [(ngModel)]="documentSearchKeywords"></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-10">
                <textarea matInput placeholder="Quicklinks"  #tileName6="ngModel" [(ngModel)]="quickLinks"></textarea>
            </mat-form-field>
        </div>

    </div>

    <div mat-dialog-actions class="dialog-actions">
        <span>
            <button class="btn btn-default" (click)="onSelect()">Save</button>
        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        </span>
    </div>
</div>